import React from 'react';
import { isMobile } from 'utils/helper/page-behavior-helper';
import styles from './styles.module.scss';

export default function Button({
  children,
  rounded,
  outlined,
  ghost,
  background,
  color,
  borderColor,
  onClick,
  disabled,
  loading,
  height,
  margin,
  width = isMobile() ? '100%' : '240px',
  minWidth,
  fontSize,
  textTransform,
  style,
  ...rest
}) {
  const customStyles = {
    height,
    width,
    minWidth,
    fontSize,
    background,
    color,
    borderColor,
    margin,
    textTransform,
    ...style
  };

  return (
    <button
      className={
        rounded && outlined
          ? styles.outlinedRoundedButton
          : rounded
          ? styles.roundedButton
          : outlined
          ? styles.outlinedButton
          : ghost
          ? styles.ghostButton
          : styles.defaultButton
      }
      onClick={onClick}
      disabled={disabled || loading}
      loading={loading?.toString()}
      style={disabled || loading ? { opacity: 0.7, pointerEvents: 'none', ...customStyles } : { ...customStyles }}
      {...rest}
    >
      {loading ? <img className="loading" src="/image/white_loader.png" alt="Carregando" /> : children}
    </button>
  );
}
